//import packages from node modules
import React,{useEffect,useRef} from 'react'
import PropTypes from 'prop-types'
import {useSelector,useDispatch} from 'react-redux'
import {withRouter} from 'react-router-dom'
import { reduxForm,Field,initialize } from 'redux-form'

//import utilities functions
import {
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../../utilities/function/common'

import {
  getAttributes
} from '../../../../utilities/function/configuration'

import {
  getCID,
  getDataFromURL
} from '../../../../utilities/function/urlparams'

import {
  getCycle,
  getPriceByBillingCycleID
} from '../../../../utilities/function/billingCycle'

import {getConfigName} from '../../../../utilities/function/manageServiceTypes'
import {updateConfig} from '../../../../app/action'

//import shared components
import Heading from '../../typography/heading'
import SolidButton from '../../button/solidbutton'
import TextField from '../../form/textfield'
import Dropdown from '../../form/dropdown'
import RadioButton from '../../form/radiobutton'

//define internal functions & variables
const vpsHostNameValidation = (v) =>{
  if (!v) return 'Please insert a Fully Qualified Domain Name e.g. vps.yourdomain.com';
  var re = /(?=^.{4,253}$)(^((?!-)[a-z\d-]{0,62}[a-z\d]\.)+[a-z]{2,63}$)/i
  return re.test(v) ? undefined :'Please insert a Fully Qualified Domain Name e.g. vps.yourdomain.com'
}
const haveCpanel = (configurations,VPSForm,cid) =>{
  const productConfig = configurations[cid]
  if(productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct) && VPSForm){
    const {config_options} = getAttributes(productConfig.selectedProduct)
    if(config_options && config_options.length > 0 && Array.isArray(config_options)){
      const osConfigOptions = config_options.find(item => item.name === "Operating System")
      if(VPSForm.values && VPSForm.values.config && osConfigOptions){
        const os_field_id = osConfigOptions.id
        const os_config_option_value = VPSForm.values.config[`config_${os_field_id}`]
        if(os_config_option_value){
          const options = osConfigOptions.options
          if(options && options.length > 0){
            const selected = options.find(item=>item.id===os_config_option_value)
            if(selected && selected.name && selected.name.indexOf('cPanel')>-1){
              return true
            }
          }
        }
      }
    }
  }
  return false
}
const getReformatConfig = (config) =>{
  if(config && Object.keys(config) && Object.keys(config).length){
    return Object.keys(config).map((key)=>{
      let config_id = parseInt(key.replace('config_',''));
      return({
        config_id,
        option_id: config[key]
      })
    })
  }
  return null
}
const getDropdownList = (options,billing_cycle_id) => {
    if (options && options.length) {
      return options.map((option) => {
        const {name, price, id} = option
        const getLeft = () => {
          return (
              <div className={'of-vps-config-dropdown__left text-font-1-100'}>
                <div className={'of-vps-config-dropdown__name'}>{name}</div>
              </div>
          )
        }
        const getRight = () => {
          const selectedPrice = getPriceByBillingCycleID(price, billing_cycle_id)
          if (selectedPrice && selectedPrice.price && selectedPrice.name) {
            const renderPrice = () => {
              const cycle = getCycle(selectedPrice.name)
              if (selectedPrice.price === "0.00") {
                return (
                    <div className={'price price--free '}>
                      <span className={'value primary-font-1-100'}>FREE</span>
                    </div>
                )
              }
              return (
                  <div className={'price'}>
                    <span className={'value'}>${parseFloat(selectedPrice.price).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</span>
                    <span className={'cycle'}>{cycle}</span>
                  </div>
              )
            }
            return (
                <div className={'of-vps-config-dropdown__right text-font-1-100'}>
                  <div className={'of-vps-config-dropdown__price'}>
                    {renderPrice()}
                  </div>
                </div>
            )
          }
          return (<></>)
        }
        return ({
          value: id,
          label: <>{getLeft()}{getRight()}</>
        })
      })
    }
    return (<></>)
}
const getRadioButtonList = (options,billing_cycle_id) => {
    if (options && options.length) {
      return options.map((option) => {
        const {name, price, id} = option
        const getLeft = () => {
          return (
              <div className={'of-vps-config-radio__left text-font-1-100'}>
                <div className={'of-vps-config-radio__name'}>{getConfigName(name)}</div>
              </div>
          )
        }
        const getRight = () => {
          const selectedPrice = getPriceByBillingCycleID(price, billing_cycle_id)
          if (selectedPrice && selectedPrice.price && selectedPrice.name) {
            const renderPrice = () => {
              const cycle = getCycle(selectedPrice.name)
              if (selectedPrice.price === '0.00') {
                return (
                    <div className={'price price--free '}>
                      <span className={'value primary-font-1-100'}>FREE</span>
                    </div>
                )
              }
              return (
                  <div className={'price'}>
                    <span className={'value'}>${parseFloat(selectedPrice.price).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</span>
                    <span className={'cycle'}>{cycle}</span>
                  </div>
              )
            }
            return (
                <div className={'of-vps-config-radio__right text-font-1-100'}>
                  <div className={'of-vps-config-radio__price'}>
                    {renderPrice()}
                  </div>
                </div>
            )
          }
          return (<></>)
        }
        return ({
          value: id,
          custom: {
            left: getLeft,
            right: getRight
          }
        })
      })
    }
    return (<></>)
}

export const WORDPRESS_MANAGEMENT_TOOLKIT = "WordPress Management Toolkit"

//form component
let VPSConfigForm = (props) =>{
  const {location,handleSubmit} = props
  const params = getDataFromURL(location.search)
  const cid = getCID(params)
  const {configurations,VPSForm} = useSelector(state=>({
    configurations: state.app.configurations,
    VPSForm: state.form.VPSForm
  }))
  const renderOSconfigOptions = () =>{
    if(cid && configurations[cid]) {
      const productConfig = configurations[cid]
      if(productConfig && productConfig.billing_cycle_id && productConfig.selectedProduct && productConfig.selectedProduct && productConfig.selectedProduct.attributes){
        const {config_options} = productConfig.selectedProduct.attributes
        const {billing_cycle_id} = productConfig
        if(config_options && config_options.length) {
          const osConfigOptions = config_options.find(item => item.name === "Operating System")
          if (osConfigOptions) {
            const {name, options, id} = osConfigOptions
            return (
              <div className={'of-vps-config__row'}>
                <Heading className={'of-vps-config__heading text-font-1-100'}>{name}</Heading>
                <Field className={'of-vps-config-radio'} component={RadioButton} list={getRadioButtonList(options,billing_cycle_id)}
                       name={`config[config_${id}]`}/>
              </div>
            )
          }

        }
      }
    }
    return (<></>)
  }
  const renderCpanelConfigOptions = () =>{
    if(cid && configurations[cid] && haveCpanel(configurations,VPSForm,cid)) {
      const productConfig = configurations[cid]
      if(productConfig && productConfig.billing_cycle_id && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)){
        const {config_options} = getAttributes(productConfig.selectedProduct)
        const {billing_cycle_id,config} = productConfig
        if(config_options && config_options.length){
          const cpanelConfigOptions = config_options.find(item => item.name === "cPanel Accounts")
          if(cpanelConfigOptions ) {
            const {name, options, id} = cpanelConfigOptions
            const getIntialValue = () =>{
              let cpanel_option = null
              if(id && Array.isArray(config) && config && config.length>0){
                cpanel_option =  config.find(item=>item.config_id===id)
              }
              if(cpanel_option && cpanel_option.option_id){
                return cpanel_option.option_id
              }
              if (options && options.length) {
                return options[0].id
              }
              return null
            }
            return (
              <div className={'of-vps-config__row'}>
                <Heading className={'of-vps-config__heading text-font-1-100'}>{name}</Heading>
                <Field className={'of-vps-config-dropdown'} component={Dropdown} list={getDropdownList(options,billing_cycle_id)}
                       name={`config[config_${id}]`} initialValue={getIntialValue()}/>
              </div>
            )
          }
        }
      }
    }
    return (<></>)
  }
  const renderWPToolkitConfigOptions = () => {
    const productConfig = configurations[cid]
    if(productConfig && getAttributes(productConfig.selectedProduct)){
      const{billing_cycle_id} = productConfig
      const {config_options} = getAttributes(productConfig.selectedProduct)
      if(config_options && config_options.length && haveCpanel(configurations,VPSForm,cid)){
        const WP_Toolkit_Option = config_options.find(i=>i.name===WORDPRESS_MANAGEMENT_TOOLKIT)
        if(WP_Toolkit_Option){
          const {id,options} = WP_Toolkit_Option
          if(options && options.length){
            return (
                <div className={'of-vps-config__row'}>
                  <Heading className={'of-vps-config__heading text-font-1-100'}>{WP_Toolkit_Option.name}</Heading>
                  <Field className={'of-vps-config-dropdown'} component={Dropdown} list={getDropdownList(options,billing_cycle_id)}
                         name={`config[config_${id}]`} initialValue={options[0].id}/>
                </div>
            )
          }

        }
        return (<></>)
      }
    }
  }
  return(
    <form className={'of-vps-config__form'} onSubmit={handleSubmit}>
      <div className={'of-vps-config__wrapper clearfix'}>
        <div className={'of-vps-config__row'}>
          <Heading className={'of-vps-config__heading text-font-1-100'}>Enter your VPS hostname</Heading>
          <Field
            component={TextField}
            name={'hostname'}
            placeholder={'e.g. vps.yourdomain.com'}
            validate={[vpsHostNameValidation]}/>
        </div>
        {renderOSconfigOptions()}
        {renderCpanelConfigOptions()}
        {renderWPToolkitConfigOptions()}
      </div>
      <SolidButton className={'of-vps-config__button'} type={'submit'}>Continue</SolidButton>
    </form>
  )
}

VPSConfigForm = reduxForm({
  form: 'VPSForm'
})(VPSConfigForm)

VPSConfigForm = withRouter(VPSConfigForm)

VPSConfigForm.propTypes = {
  location: PropTypes.object,
  handleSubmit: PropTypes.func
}

//main component
let VPSConfig = (props) =>{
  const {configurations,VPSForm} = useSelector(state=>({
    configurations: state.app.configurations,
    VPSForm: state.form.VPSForm
  }))
  const dispatch = useDispatch()
  const prevVPSForm = useRef(undefined)
  const {location} = props
  const params = getDataFromURL(location.search)
  const cid = getCID(params)
  const productConfig = configurations[cid]



  useEffect(()=>{
    if(prevVPSForm.current !== VPSForm && VPSForm && productConfig && VPSForm.values){
      const {name,config} = productConfig
      if(prevVPSForm.current===undefined){
         let values = {}
         values['hostname'] = name
         if(config && config.length>0 && name){
           values['config'] = {}
           config.forEach(item=>{
             values['config'][`config_${item['config_id']}`] = item['option_id']
           })
           dispatch(initialize('VPSForm',values))
         }
      }else{
        const {config,hostname} = VPSForm.values
        if(haveCpanel(configurations,VPSForm,cid)){
          const formated = getReformatConfig(config)
          updateConfig(configurations,cid,{
            config: formated,
            name:hostname
          },dispatch)
        }else{
          if(config && Object.keys(config) && Object.keys(config).length>0){
            let newConfig = {}
            Object.keys(config).forEach(key=>{
              if(VPSForm.registeredFields[`config[${key}]`]){
                let string = key.replace("config_","")
                newConfig = {
                  config_id: parseInt(string),
                  option_id: config[key]
                }
              }
            });
            if(newConfig && Object.keys(newConfig).length > 0){
              updateConfig(configurations,cid,{
                config: [newConfig],
                name:hostname
              },dispatch)
            }
          }
        }


      }
      prevVPSForm.current = VPSForm
    }
  },[VPSForm,prevVPSForm,dispatch,productConfig,configurations,cid])


  const handleVPSConfigForm = (values) => {
    const {hostname,config} = values
    updateConfig(configurations,cid,{
      config: getReformatConfig(config),
      step: 2,
      name: hostname
    },dispatch)
  }
  return(
    <div className={'of-step__wrapper of-vps-config'}>
      <VPSConfigForm onSubmit={handleVPSConfigForm}/>
    </div>
  )
}

VPSConfig = withRouter(VPSConfig)

VPSConfig.propTypes = {
  location: PropTypes.object
}

export default VPSConfig